import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges } from '@angular/core';

export interface ActivityDay { date: string; opens: number; visits: number }

/** Gestapeltes Tagesdiagramm (Kachel-Aufrufe + Portalbesuche) mit Hover-Tooltip und Tabellen-Alternative. */
@Component({
  selector: 'app-activity-trend-chart',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './activity-trend-chart.component.html',
  styleUrls: ['./activity-trend-chart.component.scss'],
})
export class ActivityTrendChartComponent implements OnChanges {
  @Input() days: ActivityDay[] = [];
  maxDaily = 1;
  /** Tagesindizes, deren Datum unter der Diagrammachse beschriftet wird. */
  axisTicks: number[] = [];

  ngOnChanges(): void {
    this.maxDaily = this.niceCeiling(Math.max(1, ...this.days.map(day => day.opens + day.visits)));
    const tickCount = Math.min(this.days.length, 6);
    this.axisTicks = [...new Set(Array.from({ length: tickCount },
      (_, i) => Math.round(i * (this.days.length - 1) / Math.max(1, tickCount - 1))))];
  }

  /** Rundet die Diagramm-Obergrenze auf 1/2/5 × 10^n, damit die Hilfslinien glatte Werte zeigen. */
  private niceCeiling(value: number): number {
    const magnitude = 10 ** Math.floor(Math.log10(value));
    return [1, 2, 5, 10].map(step => step * magnitude).find(step => step >= value) ?? value;
  }
}
